export default __webpack_public_path__ + "static/media/amazontv-new.00248641.png";